"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddChildNode = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const AddChildNode = ({ size = 16 }) => (react_1.default.createElement(Base_1.Base, { size: size },
    react_1.default.createElement("path", { fill: "#E6E6E6", d: "M9,12v1H4H3v-1V7H0V0h7v7H4v5H9z" }),
    react_1.default.createElement("path", { fill: "#8EE43F", d: "M9,9v7h7V9H9z M15,13h-2v2h-1v-2h-2v-1h2v-2h1v2h2V13z" })));
exports.AddChildNode = AddChildNode;
//# sourceMappingURL=AddChildNode.js.map